// extracted by mini-css-extract-plugin
module.exports = {"noScroll":"loading-overlay_noScroll__KdlX_","overlay":"loading-overlay_overlay___ld4z","hide":"loading-overlay_hide__BSUFv","loadingText":"loading-overlay_loadingText__kfOcl"};